export default __webpack_public_path__ + "static/char-s-53-en-58498c671c7fffb4b0343f17b4f3ea7d.webp";